// src/components/PinisiKata/PinisiBreakScreen.js
import React from 'react';
import styles from './PinisiKata.module.css';
import { ACTIONS } from './PinisiKataGame';

/**
 * Komponen PinisiBreakScreen menampilkan skor sementara antara level
 * dan tombol untuk melanjutkan ke level berikutnya.
 * @param {object} props
 * @param {object} props.state - Objek state lengkap dari reducer (termasuk skor dan level).
 * @param {function} props.dispatch - Fungsi dispatch untuk mengirim aksi.
 */
function PinisiBreakScreen({ state, dispatch }) {
    const { player1Score, player2Score, level } = state;

    const handleContinue = () => {
        // Mengirim aksi untuk melanjutkan ke level selanjutnya
        dispatch({ type: ACTIONS.CONTINUE_TO_NEXT_LEVEL });
    };
    
    const handleBackToLevels = () => {
        // Mengirim aksi untuk kembali ke layar pemilihan level
        dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'level' } });
    };

    return (
        <div className={`${styles.screen} ${styles.levelBreakScreen} ${styles.active}`}>
            {/* Tombol untuk kembali ke pemilihan level (opsional, tapi bagus untuk UX) */}
            <button className={styles.backButton} onClick={handleBackToLevels} title="Pilih Level">
                ⚙️
            </button>

            <h2 className={styles.breakTitle}>SKOR SEMENTARA</h2>

            <div className={styles.scoreSummary}>
                <div className={styles.scoreRow}>
                    <span style={{ color: '#d32f2f' }}>🔴 TIM MERAH:</span>
                    <span>{player1Score}</span>
                </div>
                <div className={styles.scoreRow}>
                    <span style={{ color: '#1976d2' }}>🔵 TIM BIRU:</span>
                    <span>{player2Score}</span>
                </div>
            </div>

            <button className={styles.continueButton} onClick={handleContinue}>
                LANJUT KE LEVEL {level + 1}
            </button>
        </div>
    );
}

export default PinisiBreakScreen;